import { render, staticRenderFns } from "./ouUsers.vue?vue&type=template&id=54b764ba&scoped=true&"
import script from "./ouUsers.vue?vue&type=script&lang=ts&"
export * from "./ouUsers.vue?vue&type=script&lang=ts&"
import style0 from "./ouUsers.vue?vue&type=style&index=0&id=54b764ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b764ba",
  null
  
)

export default component.exports